import { Box } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { FC } from "react"

import { useGetTransferComment } from "../../hooks/useGetTransferComment"
import type { TransferPalletWithProduct } from "../../types"
import { calculateTransferTotals, isTransferWorkOrderCreated } from "../../utils"
import { TransferTotalsSummary } from "../TransferTotalsSummary"

import { TransferPalletsTable } from "./TransferPalletsTable"

import type { Transfer } from "@/graphql/codegen/graphql"

interface TransferRowDetailsProps {
  row: Row<Transfer>
  isPrinting: boolean
  onPalletLabelPrint: (pallet: TransferPalletWithProduct) => void
}

export const TransferRowDetails: FC<TransferRowDetailsProps> = ({ row, isPrinting, onPalletLabelPrint }) => {
  const transfer = row.original
  const { comment } = useGetTransferComment(transfer.transferId)
  const totals = calculateTransferTotals(transfer.products)

  return (
    <Box className='flex flex-col gap-y-6 p-6'>
      {comment && (
        <div className='flex flex-col gap-y-1'>
          <span className='text-sm font-medium text-gray-900'>Comment</span>
          <span className='text-sm text-gray-700'>{comment.value}</span>
        </div>
      )}
      <TransferPalletsTable
        data={transfer.products}
        uomName={totals.uomName}
        isPrinting={isPrinting}
        canPrintPalletLabel={isTransferWorkOrderCreated(transfer)}
        onPalletLabelPrint={onPalletLabelPrint}
      />
      <TransferTotalsSummary totals={totals} />
    </Box>
  )
}
